import { render } from "./AlzataEditRouteDialog.vue?vue&type=template&id=05b88de2"
import script from "./AlzataEditRouteDialog.vue?vue&type=script&lang=js"
export * from "./AlzataEditRouteDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__